import { useReports } from '@sail/observability';
import { once } from '@sail/utils';
import { useContext } from 'react';
import IntlConfigContext from '../internal/config/IntlConfigContext';
import defaultConfig from '../internal/config/defaultConfig';
class IntlConfigError extends Error {
    constructor(message){
        super(`[@sail/intl] ${message}`);
    }
}
const reportUninitializedErrorOnce = once((report)=>{
    const error = new IntlConfigError('Make sure to provide the required config for intl to IntlProvider upon initialization.');
    report(error, {
        tags: {
            namespace: 'intl'
        }
    });
});
export default function useIntlConfig() {
    const config = useContext(IntlConfigContext);
    const { error } = useReports();
    if (config === defaultConfig) {
        reportUninitializedErrorOnce(error);
    }
    return config;
}

//# sourceMappingURL=useIntlConfig.js.map